import React, { useState } from 'react'
import { expand } from '../../Images/Icons';
import ReactApexChart from "react-apexcharts";

const ChartSectionFull = () => {
    const [state, setNewState] = useState({
        series: [{
            name: 'PV output',
            color: '#0FC637',
            data: [null, null, null, null, null, null, null]
        }, {
            name: 'Total consumption',
            color:'#F66453',
            data: [11, 32, 30, 32, 34, 40, 35],
            hidden: true
        }, {
            name: 'Consumed from PV',
            color:'#3698FF',
            data: [31, 40, 28, 51, 42, 45, 39]
        }, {
            name: 'Battery (charge)',
            color:'#D090D6',
            data: [null, null, null, null, null, null, null]
        }, {
            name: 'Battery (discharge)',
            color:'#FC891F',
            data: [null, null, null, null, null, null, null]
        }],
        options: {
            chart: {
                height: 350,
                type:  'area'
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                type: 'datetime',
                categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy HH:mm'
                },
            },

        },
        
        
        
    });

    const setState = data => {
        setNewState(prev => ({ ...prev, ...data }))
    }

    const { series, options } = state;

    return (
        <div>
            {/* <div style={{width: '100%',height:30, top:33,zIndex:99, position:'relative',background:'#fff', fontSize:'12px',color:'#7B7E87', paddingLeft:15, paddingTop:10}}>kW</div> */}

            <div id="chart-area" style={{marginTop: 0}}>
                <ReactApexChart options={options} series={series} type="area" height={280} />
            </div>
        </div>
    )
}

export default ChartSectionFull